import { render } from "./Preloading.vue?vue&type=template&id=707abf5a&scoped=true"
import script from "./Preloading.vue?vue&type=script&lang=js"
export * from "./Preloading.vue?vue&type=script&lang=js"

import "./Preloading.vue?vue&type=style&index=0&id=707abf5a&lang=stylus&scoped=true"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707abf5a"]])

export default __exports__